import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class TypeStockService {
  //private apiUrl = '/typestocks';
  private apiSpringUrl = '/spring/typestocks';

  constructor(private http: HttpService) {}

  get(): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl;
    return this.http.get(url);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/type-stock/type-stock.service.ts